import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

export const useStyles = makeStyles()((theme: Theme) => ({
  wrapper: {
    position: 'fixed',
    bottom: 32,
    right: 32,
    zIndex: 1300,
  },
  button: {
    background:
      'linear-gradient(114.88deg, rgb(255,112,138) 31.244%, rgb(191,84,142) 53.577%, rgb(115,52,149) 78.991%)',
    borderRadius: 28,
    padding: '12px 20px',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    boxShadow: '0px 4px 16px rgba(0,0,0,0.2)',
    transition: 'transform 0.15s ease',
    '&:hover': {
      transform: 'scale(1.02)',
    },
  },
  icon: {
    fontSize: 16,
    color: theme.palette.text.white,
  },
  label: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 14,
    color: theme.palette.text.white,
    whiteSpace: 'nowrap',
  },
}))
